import {Pipe, PipeTransform} from "@angular/core";
import {AudioInputChannel} from "@models";

@Pipe({
	name: "castToAudioInputChannels",
	pure: false,
	standalone: false,
})
export class CastToAudioInputChannelsPipe implements PipeTransform {
	transform(audioInputChannels: any[]): AudioInputChannel[] {
		return <AudioInputChannel[]>audioInputChannels;
	}
}
